import { render, staticRenderFns } from "./AcademicDialog.vue?vue&type=template&id=400918bd&scoped=true&"
import script from "./AcademicDialog.vue?vue&type=script&lang=js&"
export * from "./AcademicDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400918bd",
  null
  
)

export default component.exports